import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/agents/id/trigger/page';

export const Route = createFileRoute('/_app/_chat/agents/$id/trigger/')({
  component: Page,
});
